import { type CommonAction, response, success } from "@iflyrpa/share";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { DisabledReq } from "../../types";
import { Http } from "../../utils/http";
import { Xhshow } from "../../utils/xhsXsEncrypt";

// 小红书参数加密器
const xsEncrypt = new Xhshow();

export interface xiaohongshuWebCommentActionParams extends ActiomCommonParams {
    note_id: string;
    comment_id: string;
    action: "like" | "dislike";
}
export interface ActionResponse {
    code: number;
    success: boolean;
    msg: string;
}

export type PublishAction = CommonAction<xiaohongshuWebCommentActionParams, ActionResponse | Record<string, never>>;

export const xiaohongshuWebCommentAction: PublishAction = async (_task, params) => {
    if (DisabledReq) return response(414, "点赞相关操作失败", {});
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://www.xiaohongshu.com/",
        origin: "https://www.xiaohongshu.com/",
    };

    const args: AxiosProxyParams = [{ headers }, _task.logger, params.proxyLoc, params.accountId];
    const http = new Http(...args);

    const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    if (!a1Cookie) return { code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: [] };
    if (!params.note_id && !params.comment_id && !params.action) {
        return { code: 414, message: "参数缺失，请检查后重试！", data: {} };
    }

    const actionParams = {
        note_id: params.note_id,
        comment_id: params.comment_id,
    };

    let likeActionRes: ActionResponse = { code: 500, success: false, msg: "" };
    const recordCookie = params.cookies.reduce<Record<string, string>>((acc, cookie) => {
        if (cookie.name && cookie.value) {
            acc[cookie.name] = cookie.value;
        }
        return acc;
    }, {});

    switch (params.action) {
        case "like": {
            const likeAction = "/api/sns/web/v1/comment/like";
            const likeActionXsHeader = xsEncrypt.signHeadersPost(likeAction, recordCookie, "xhs-pc-web", actionParams);

            likeActionRes = await http.api<ActionResponse>(
                {
                    method: "post",
                    url: "https://edith.xiaohongshu.com/api/sns/web/v1/comment/like",
                    data: actionParams,
                    headers: likeActionXsHeader,
                },
                { retries: 3, retryDelay: 20, timeout: 3000 },
            );
            break;
        }

        case "dislike": {
            const dislikeMentions = "/api/sns/web/v1/comment/dislike";
            const dislikeXsHeader = xsEncrypt.signHeadersPost(
                dislikeMentions,
                recordCookie,
                "xhs-pc-web",
                actionParams,
            );

            likeActionRes = await http.api<ActionResponse>(
                {
                    method: "post",
                    url: "https://edith.xiaohongshu.com/api/sns/web/v1/comment/dislike",
                    data: actionParams,
                    headers: dislikeXsHeader,
                },
                { retries: 3, retryDelay: 20, timeout: 3000 },
            );
            break;
        }

        default:
            return { code: 414, message: "参数action错误，请重试！", data: {} };
    }

    const isSuccess = likeActionRes.code === 0;
    const message = `点赞相关操作${isSuccess ? "成功" : `失败，原因：${likeActionRes.msg}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;
    const data = isSuccess ? likeActionRes.success : {};

    return response(isSuccess ? 0 : 414, message, data);
};
